'use client';

import { Input } from 'src/components/PulseUI';

interface DataIssueEmailProps {
  email: string;
  setEmail: (value: string) => void;
}

const DataIssueEmail = ({ email = '', setEmail }: DataIssueEmailProps) => {
  return (
    <div className="mt-2" data-testid="data-issue-email">
      <label htmlFor="data-issue-email-input" className="text-sm font-medium">
        If you found the correct email, please provide it below:
      </label>
      <Input
        id="data-issue-email-input"
        type="email"
        placeholder="Email"
        value={email || ''}
        onChange={(e) => setEmail(e.target.value)}
        aria-label="Email address"
        data-testid="data-issue-email-input"
      />
    </div>
  );
};

export { DataIssueEmail };
